<template>
  <base-layout :query="require('@/graphql/Study.gql')" :variables="{slug: slug}">
    <template v-slot:title="props">
      <top :titleText="props.data.studies.edges[0].node.title" :nameText="props.data.studies.edges[0].node.title" class="orange"/>
    </template>
    <template v-slot:main-section="props">
      <article class="study u-bg--white u-align--left">
        <div class="top">
          <div class="infos">
            <tag v-if="props.data.studies.edges[0].node.type" :tag="props.data.studies.edges[0].node.type" class="u-color--orange u-bg--orange-soft"/>
            <pathology :pathology="props.data.studies.edges[0].node.pathology.name"/>
          </div>
          <PrintButton/>
        </div>

        <h3>{{props.data.studies.edges[0].node.chapo}}</h3>

        <div class="details" v-html="props.data.studies.edges[0].node.criteria"></div>

        <title-simple :text="'Porteur du projet'" :hasBlock="true"/>

        <div class="project-leader">
          <div class="coordinates">
            <span><strong>{{props.data.studies.edges[0].node.contactName}}</strong>, </span><span v-html="props.data.studies.edges[0].node.address"></span>
            <span v-if="props.data.studies.edges[0].node.contactEmail">Contact&nbsp;: {{props.data.studies.edges[0].node.contactEmail}}</span>
          </div>

          <round-button-icon :targetBlank="true" :text="'S\'inscrire'" class="u-bg--orange" :href="props.data.studies.edges[0].node.subscriptionUrl"/>
        </div>

        <span>Clôture des inclusions au <strong>{{parseDate(props.data.studies.edges[0].node.maxSubscriptionDate)}}</strong></span>

        <title-simple :text="'Description'" :hasBlock="true"/>

        <RichText :dataHtml="props.data.studies.edges[0].node.body"></RichText>

        <div class="project-leader bottom">
          <div class="coordinates">
            <span><strong>{{props.data.studies.edges[0].node.contactName}}</strong>,</span><span v-html="props.data.studies.edges[0].node.address"></span>
            <span v-if="props.data.studies.edges[0].node.contactEmail">Contact&nbsp;: {{props.data.studies.edges[0].node.contactEmail}}</span>
          </div>

          <round-button-icon :text="'S\'inscrire'" :targetBlank="true" class="u-bg--orange" :href="props.data.studies.edges[0].node.subscriptionUrl"/>
        </div>
      </article>
    </template>

    <template v-slot:card-section="props">
      <card-study :study="props.data.studies.edges[0]" :flatButton="true"></card-study>
      <card-simple-actu :actu="props.data.infos.edges[0]" :flatButton="true"></card-simple-actu>
    </template>
  </base-layout>
</template>

<script>
  import BaseLayout from "../components/Layout/BaseLayout";
  import Pathology from "../components/Card/Granular/Pathology";
  import Tag from "../components/Card/Granular/Tag";
  import PrintButton from "../components/Core/PrintButton";
  import TitleSimple from "../components/Core/TitleSimple";
  import RoundButtonIcon from "../components/Core/RoundButtonIcon";
  import CardSimpleActu from "../components/Card/Models/Card-simple-actu";
  import Top from "../components/Core/Top";
  import CardStudy from "../components/Card/Models/Card-study";
  import RichText from "../components/Core/RichText";
  import { apolloClient } from '@/vue-apollo';

  export default {
    name: "Study",
    components: {
      RichText,
      CardStudy,
      Top,
      CardSimpleActu, RoundButtonIcon, TitleSimple, PrintButton, Tag, Pathology, BaseLayout
    },
    data: () => {
      return {
        slug: ''
      }
    },
    mounted() {
      this.slug = this.$route.params.slug;
    },

    beforeRouteEnter(to, from, next) {
      // On appelle la requete GQL GetStudy() en se basant sur le slug fourni.
      apolloClient.query({
        query: require('../graphql/Study.gql'),
        variables: {
          slug: to.params.slug
        }
      })
      // On recupere le node 'studies'
      .then(({ data: { studies } }) => {

        // Si aucune studies, alors page not found
        if (!studies.edges.length) {
          next({name: 'not-found'}); // j'aurais aimé conservé rediriger vers not-found sans changer l'url, mais pas trouvé
        } else {
          // sinon on continue.
          next();
        }
      })},

     methods: {
      parseDate(date) {
        let d = date.split(' ')[0].split('-'),
          event = new Date(Date.UTC(d[0], d[1], d[2], 0, 0, 0)),
          options = {year: 'numeric', month: 'long', day: 'numeric'};

        return event.toLocaleDateString('fr-FR', options)
      },
    }
  }
</script>

<style lang="scss">
    .study {
      border: 1px solid color(border);
      box-shadow: 0 2px 6px 0 rgba(0,0,0,0.08);
      padding: rem(25px) rem(30px) rem(30px);
      font-size: rem(14px);
      line-height: rem(24px);

      .top {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        position: relative;
        padding-bottom: rem(25px);
        margin-bottom: rem(30px);

        &::after {
          position: absolute;
          content: '';
          left: 0;
          bottom: 0;
          height: 1px;
          width: 100%;
          background-color: color(border);
        }

        .infos {
          display: flex;
          align-items: center;
          flex-wrap: wrap;

          @include mq($until: MD) {
            margin-bottom: rem(10px);
          }

          .tag {
            margin: 0 rem(10px) 0 0;
          }
        }
      }

      .details {
        border: 1px solid color(border);
        display: flex;
        margin-top: rem(30px);

        ul {
          padding: 0;
          margin: 0;
          list-style: none;
        }

        .label, .content {
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          padding: rem(12px) rem(20px);
          white-space: nowrap;
          list-style: none;

          @include mq($until: MD) {
            padding: rem(10px);
            font-size: rem(12px);
          }
        }

        .label {
          font-weight: 700;
        }
      }

      .title-without-link {
        margin-top: rem(50px);
      }

      h3 {
        font-size: rem(16px);
        line-height: rem(24px);
      }

      .project-leader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;

        .coordinates {
          display: flex;
          flex-direction: column;
        }

        .cta-round {
          margin-top: 0;

          @include mq($until: MD) {
            margin: rem(10px) 0;
          }

          &:hover {
            background-color: color(orange-hover);
          }
      }

        &.bottom {
          padding-top: rem(25px);
          margin-top: rem(30px);
          position: relative;

          &::before {
            position: absolute;
            content: '';
            left: 0;
            top: 0;
            height: 1px;
            width: 100%;
            background-color: color(border);
          }
        }
      }

      @include mq($until: MD) {
        padding: rem(20px) rem(10px);
        margin: 0 rem(10px);
      }
    }
</style>